import { __rest, __assign } from 'tslib';
import { jsx } from '@emotion/react/jsx-runtime';
import { forwardRef, Fragment } from 'react';
import Portal from '../node_modules/@reach/portal/dist/reach-portal.esm.js';
import { PopoverImpl } from './PopoverImpl.js';

var Popover = forwardRef(function Popover(_a, ref) {
    var _b = _a.portal, portal = _b === void 0 ? true : _b, props = __rest(_a, ["portal"]);
    var Wrapper = portal ? Portal : Fragment;
    return (jsx(Wrapper, { children: jsx(PopoverImpl, __assign({ ref: ref }, props)) }));
});

export { Popover };
//# sourceMappingURL=Popover.js.map
